// audit-log.ts — Endpoints journal d'audit (admin only, perm audit_log.read).
import { req } from './_internals.js';

export const auditLogApi = {
  getAuditLog: (params?: Record<string, string> | null) => {
    const qs = params ? '?' + new URLSearchParams(params).toString() : '';
    return req('GET', '/audit-log' + qs);
  },
  getAuditLogActions: () => req('GET', '/audit-log/actions'),
};
